import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateProjectObjectPropertiesDynamic } from "../../helpers/axios/objectsAxios";
import {
  DATA_CHANGES,
  SELECTED_OBJECT_DATA,
  updateModelState,
} from "../../helpers/reducers/ModelReducer";
import { getAllFluids } from "../../helpers/axios/fluidsAxios";
import LoadingScreen from "../loadingScreen/LoadingScreen";
import Modal from "react-bootstrap/Modal";
import * as _ from "lodash";

const Properties = (props) => {
  const {
    selectedTag,
    selectedObjectData,
    selectedObjectDataLoading,
    dataChanges,
  } = useSelector((state) => state.modelReducer);
  // const { objectCategory } = useSelector((state) => state.navigationReducer);
  const [showEditObjectModal, setShowEditObjectModal] = useState(false);
  const [propertyData, setPropertyData] = useState([]);
  const [fluids, setFluids] = useState([]);
  const [propertySearch, setPropertySearch] = useState("");
  const dispatch = useDispatch();

  //use effect to load fluids and set them to state
  useEffect(() => {
    (async () => {
      let tempFluids = await getAllFluids();
      setFluids(tempFluids);
    })();
  }, []);

  useEffect(() => {
    // let tempData = null;
    // let tempProps = null;

    // if (showAll) {
    // switch (objectCategory) {
    //   case "All Classes":
    //     tempData = modelData.sort((a, b) => (a.tag > b.tag ? 1 : -1));
    //     break;
    //   default:
    //     tempData = modelData
    //       .filter((o) => o.category === objectCategory)
    //       .sort((a, b) => (a.tag > b.tag ? 1 : -1));
    //     break;
    // }

    // if (showSelection) {
    //   // const tempModelData = modelData.slice();
    //   // tempData = tempModelData.filter((o) => o.guid === selectedGuid).sort((a, b) => (a.tag > b.tag ? 1 : -1));

    // }

    if (selectedObjectData) {
      // const tempObjectData = { ...selectedObjectData };
      const tempObjectData = _.cloneDeep(selectedObjectData);
      setPropertyData(tempObjectData);
    }
  }, [selectedTag, selectedObjectData]);

  // const dynaValueChangeHandler = (id, name, value) => {
  //   //Copy of the selected models property data
  //   let tempSelectedModelData = propertyData.slice();
  //   //Loop over the model data and update the value of the selected property
  //   const updatedModelData = tempSelectedModelData.map((object) => {
  //     //Copy of the changed properties
  //     let tempChangedProps = changedPropsLocal.slice();
  //     if (object.guid === id) {
  //       const tempProps = object.properties.slice();
  //       //Loop over each property if found update otherwise add to temporary array
  //       tempProps.forEach((prop) => {
  //         if (prop.objectProperty.property === name) {
  //           prop.objectProperty.value = value;
  //           const changedProp = tempChangedProps.find((o) => o.id === prop.id);
  //           if (changedProp) {
  //             changedProp.objectProperty.value = value;
  //           } else {
  //             tempChangedProps.push(prop);
  //           }
  //           setChangedProps(tempChangedProps);
  //         }
  //       });
  //       return { ...object, properties: tempProps };
  //     } else {
  //       return object;
  //     }
  //   });
  //   // setPropertyData(updatedModelData);
  // };

  const updateObjectDynamicValue = (name, value) => {
    let tempProps = propertyData.properties.slice();
    let prop = tempProps.find((o) => o.objectProperty.property === name);
    prop.objectProperty.value = value;
    setPropertyData({ ...propertyData, properties: tempProps });
  };

  const saveDataButtonHandler = async () => {
    await updateProjectObjectPropertiesDynamic(propertyData).then((res) => {
      window.alert("Data saved");
      var tempSelectedObjectData = _.cloneDeep(selectedObjectData);
      //loop over all dynamic properties and update the values
      for (
        let index = 0;
        index < tempSelectedObjectData.properties.length;
        index++
      ) {
        const prop = tempSelectedObjectData.properties[index];
        let dbMatch = res.data.projectObjectProperties.find(
          (o) => o.property === prop.objectProperty.property,
        );
        prop.objectProperty.value = dbMatch?.value ?? prop.objectProperty.value;
      }
      dispatch(
        updateModelState({
          value: tempSelectedObjectData,
          stateName: SELECTED_OBJECT_DATA,
        }),
      );

      var tempDataChanges = _.cloneDeep(dataChanges);
      //check if tempDataChanges contains propertyData if not add it otherwise replace it
      var tempDataChange = tempDataChanges.find(
        (o) => o.projectObjectId === propertyData.projectObjectId,
      );
      if (tempDataChange) {
        tempDataChange = propertyData;
      } else {
        tempDataChanges.push(propertyData);
      }
      dispatch(
        updateModelState({
          value: tempDataChanges,
          stateName: DATA_CHANGES,
        }),
      );
    });
  };

  const displayInput = (guid, prop) => {
    switch (prop.objectProperty.type) {
      case "Fluid":
        return (
          <Select
            className="properties-panel__select"
            classNamePrefix="properties-panel-select"
            onChange={(e) =>
              updateObjectDynamicValue(prop.objectProperty.property, e.value)
            }
            options={fluids?.map((f) => {
              return {
                value: f.code + "-" + f.description,
                label: f.code + "-" + f.description,
              };
            })}
            placeholder="Choose a fluid"
            value={{
              value: prop.objectProperty.value,
              label: prop.objectProperty.value,
            }}
          ></Select>
        );
      case "Dropdown":
        return (
          <Select
            className="properties-panel__select"
            classNamePrefix="properties-panel-select"
            onChange={(e) =>
              updateObjectDynamicValue(prop.objectProperty.property, e.value)
            }
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 999,
              }),
            }}
            options={prop.objectProperty.options?.split(",").map((opt) => {
              return { value: opt, label: opt };
            })}
            placeholder="Filter by object type"
            value={{
              value: prop.objectProperty.value,
              label: prop.objectProperty.value,
            }}
          ></Select>
        );
      case "Number":
        return (
          <input
            className="form-control form-control-sm properties-panel__input"
            type="number"
            value={prop.objectProperty.value}
            onChange={(e) =>
              updateObjectDynamicValue(
                prop.objectProperty.property,
                e.target.value,
              )
            }
          ></input>
        );
      // case "Hyperlink":
      //   return (
      //     <a href={prop.objectProperty.value} target="_blank" rel="noreferrer">
      //       {prop.objectProperty.value}
      //     </a>
      //   );
      default:
        return (
          <input
            className="form-control form-control-sm properties-panel__input"
            type="text"
            value={prop.objectProperty.value ?? ""}
            onChange={(e) =>
              updateObjectDynamicValue(
                prop.objectProperty.property,
                e.target.value,
              )
            }
          ></input>
        );
    }
  };

  const table = (
    title,
    properties,
    guid,
    origin,
    category = "",
    sectionKey = "default",
  ) => {
    if (!properties?.length) return null;

    return (
      <>
        {category === "Invalid MUID" && (
          <p className="properties-panel__warning">
            Object selected has an MUID in the 3D model but not in the database,
            please contact an admin to add it.
          </p>
        )}
        <section
          className={`properties-panel__section properties-panel__section--${sectionKey}`}
          aria-label={title}
        >
          <header className="properties-panel__section-header">
            <div className="properties-panel__section-headline">
              <h5 className="properties-panel__section-title">
                <span
                  className={`properties-panel__section-icon properties-panel__section-icon--${sectionKey}`}
                />
                {title}
              </h5>
              <span className="properties-panel__count-chip">
                {properties.length}
              </span>
            </div>
            <div className="properties-panel__section-columns">
              <span>Property</span>
              <span>Value</span>
            </div>
          </header>
          <div className="properties-panel__rows">
            {properties.map((prop, index) => {
              const propName =
                origin === "Other"
                  ? prop.displayName
                  : prop.objectProperty.property;

              let propValue = null;
              if (origin === "Dynamic") {
                propValue = displayInput(guid, prop);
              } else if (origin === "Static" || origin === "3D") {
                propValue =
                  prop.objectProperty.type === "Hyperlink" ? (
                    <a
                      className="properties-panel__link"
                      href={prop.objectProperty.value}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {prop.objectProperty.value}
                    </a>
                  ) : (
                    <span>{prop.objectProperty.value}</span>
                  );
              } else {
                propValue =
                  prop.displayName === "URL" ? (
                    <a
                      className="properties-panel__link"
                      href={prop.displayValue}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {prop.displayValue}
                    </a>
                  ) : (
                    <span>{prop.displayValue}</span>
                  );
              }

              return (
                <div
                  className="properties-panel__row"
                  key={`${propName}-${index}`}
                >
                  <div className="properties-panel__name-cell">{propName}</div>
                  <div className="properties-panel__value-cell">
                    {propValue}
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </>
    );
  };

  //close Modal Function
  const closeModal = () => {
    if (
      window.confirm("Are you sure you want to close without saving changes?")
    ) {
      setShowEditObjectModal(false);
    }
  };

  return (
    <>
      <Modal
        size="lg"
        show={showEditObjectModal}
        onHide={closeModal}
        dialogClassName="project-info-modal properties-panel-modal"
        centered
      >
        <Modal.Header className="project-info-modal__header properties-panel-modal__header">
          <Modal.Title>Edit Properties</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close project-info-modal__close"
              onClick={closeModal}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body
          style={{ overflow: "auto", maxHeight: "85vh" }}
          className="project-info-modal__body properties-panel-modal__body"
        >
          {table(
            "Dynamic properties",
            propertyData.properties
              ?.filter((o) => o.objectProperty?.origin === "Dynamic")
              .sort((a, b) =>
                a.objectProperty?.property > b.objectProperty?.property
                  ? 1
                  : -1,
              ),
            propertyData.guid,
            "Dynamic",
            propertyData.category,
            "dynamic",
          )}
          {/* Buttons */}
        </Modal.Body>
        <Modal.Footer className="project-info-modal__body properties-panel-modal__footer">
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-outline-success project-status-modal__action-btn properties-panel-modal__action-btn"
              onClick={async (e) => {
                //Save Changes
                saveDataButtonHandler();
                setShowEditObjectModal(false);
              }}
            >
              Save
            </button>
            <button
              className="btn btn-outline-danger project-status-modal__action-btn properties-panel-modal__action-btn"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <div className="properties-panel">
        {/* <h2>Object Properties</h2> */}
        {selectedObjectDataLoading && (
          <LoadingScreen
            input="LOADING"
            width="15"
            marginTop="0"
            variant="properties"
            transparent
          />
        )}

        {propertyData && !selectedObjectDataLoading && (
          <div className="row mb-2">
            {/* {propertyData.tag && (
              <div className="col-6 d-flex align-items-center">
                Selected tag number: {propertyData.tag}
              </div>
            )} */}

            {/* {propertyData?.muid &&
              propertyData?.category !== "Invalid MUID" && (
                <div className="d-grid mt-2">
                 
                  <button
                    className="btn btn-md-block btn-success btn-sm me-1"
                    onClick={() => {
                      setShowEditObjectModal(true);
                    }}
                  >
                    Edit Dynamic Properties
                  </button>
                </div>
              )} */}
            <div className="col-12 properties-panel__toolbar-wrap">
              <div className="properties-panel__toolbar">
                <label
                  htmlFor="propertiesSearch"
                  className="properties-panel__search-label"
                >
                  Find property
                </label>
                <input
                  id="propertiesSearch"
                  type="text"
                  className="form-control properties-panel__search-input"
                  placeholder="Search property names..."
                  value={propertySearch}
                  onChange={(e) => setPropertySearch(e.target.value)}
                />
                {propertySearch && (
                  <button
                    type="button"
                    className="btn btn-outline-danger project-status-modal__action-btn properties-panel__clear-btn"
                    onClick={() => setPropertySearch("")}
                  >
                    Clear
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        {/* <Select
        onChange={(e) => objectCategoryFilterHandler(e)}
        options={[{ value: "All Classes", label: "All Classes" }].concat(
          modelCategories?.map((category) => {
            return { value: category, label: category };
          })
        )}
        placeholder="Filter by object type"
        className="p-1"
      /> */}
        <div>
          {(!propertyData || propertyData?.length === 0) &&
            !selectedObjectDataLoading && (
              <>
                <h4 className="properties-panel__empty">
                  Please select an object in the 3D model to view its properties
                  below.
                </h4>
              </>
            )}

          {/* <LoadingScreen input="LOADING" position="fixed" height="100%" /> */}
          {propertyData && !selectedObjectDataLoading && (
            <>
              {/* <div className="accordion" id="propertiesAccordion" key={index}>
                <div className="accordion-item">
                  <h2 className="accordion-header" id={index}>
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={"#collapse-" + index}
                      aria-expanded="false"
                      aria-controls={"collapse-" + index}
                    >
                      {object.category &&
                        `${object.category} --- ${object.tag}`}
                    </button>
                  </h2>
                  <div
                    id={"collapse-" + index}
                    className="accordion-collapse collapse"
                    aria-labelledby={index}
                    data-bs-parent="#propertiesAccordion"
                  >
                    <div className="accordion-body"> */}
              <div className="bs-component OPMTable properties-panel__table-wrap">
                {table(
                  "Static Properties",
                  propertyData.properties
                    ?.filter(
                      (o) =>
                        o.objectProperty?.origin === "Static" ||
                        o.objectProperty?.origin === "3D",
                    )
                    .filter((o) => {
                      if (!propertySearch?.trim()) return true;
                      return o.objectProperty?.property
                        ?.toLowerCase()
                        .includes(propertySearch.toLowerCase().trim());
                    })
                    .sort((a, b) =>
                      a.objectProperty?.property > b.objectProperty?.property
                        ? 1
                        : -1,
                    ),
                  propertyData.guid,
                  "Static",
                  propertyData.category,
                  "static",
                )}
                {/* {table(
                  "Dynamic Properties",
                  selectedObjectData?.properties
                    ?.filter((o) => o.objectProperty?.origin === "Dynamic")
                    .sort((a, b) =>
                      a.objectProperty?.property > b.objectProperty?.property
                        ? 1
                        : -1,
                    ),
                  propertyData.guid,
                  "Static",
                  propertyData.category
                )} */}
                {table(
                  "3D Model Properties",
                  propertyData.properties
                    ?.filter((o) => !o.objectProperty)
                    .filter((o) => {
                      if (!propertySearch?.trim()) return true;
                      return o.displayName
                        ?.toLowerCase()
                        .includes(propertySearch.toLowerCase().trim());
                    })
                    .sort((a, b) => (a.displayName > b.displayName ? 1 : -1)),
                  propertyData.guid,
                  "Other",
                  propertyData.category,
                  "model",
                )}
              </div>
              {/* </div>
                  </div>
                </div>
              </div> */}
            </>
          )}
        </div>
        <br></br>
      </div>
    </>
  );
};

export default Properties;
